import React from 'react';

const JS_Exercises = () => {
  return (
    <div >
      <h1>JS_Exercises</h1>
      <p>Placeholder component for: "JS Exercises"</p>
    </div>
  );
};

export default JS_Exercises;
